import { reportApiFailure } from "utils/api-errors";

export async function fetchVideoCaption(src: string, signal: AbortSignal): Promise<Blob> {
  let failureCategory = "network or CORS";
  try {
    // Asset URLs must not receive Forum's API bearer token or cross-origin cookies.
    const response = await fetch(src, { signal, mode: "cors", credentials: "same-origin" });
    if (!response.ok) {
      failureCategory = `HTTP ${response.status}`;
      throw new Error(`Caption request failed (${response.status})`);
    }
    // Existing uploads may be served as application/octet-stream.
    return new Blob([await response.blob()], { type: "text/vtt" });
  } catch (error) {
    if (!signal.aborted) reportApiFailure("fetchVideoCaption", error, failureCategory);
    throw error;
  }
}
